import { Component, HostListener, OnInit, ViewChild, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { Icons } from '@vex/icons/icons';
import { HelperService } from '@vex/services/helper.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { FormGroup } from '@angular/forms';
import { PageSizeOptions } from '@vex/constants/settings';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription, Subject } from 'rxjs';
import { distinctUntilChanged, debounceTime, filter } from 'rxjs/operators';
import {
  MonacoEditorConstructionOptions,
  MonacoStandaloneCodeEditor
} from '@materia-ui/ngx-monaco-editor';
import { AiService } from '@vex/http-service/ai.service';
import { CloudConnectStateService } from '@vex/constants/cloud-connect-state';
import { DependencyMapService } from '@vex/http-service/dependency-map.service';
import { AskByInventoryIdViewModel } from '@vex/model/ai';
import { KumobotService } from '@vex/services/kumobot/kumobot.service';
import { GlobalSearchCardComponent } from '@vex/components/global-search/global-search-card/global-search-card.component';

declare var uuid: any;
@Component({
  selector: 'vex-global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.scss']
})
export class GlobalSearchComponent extends Icons implements OnInit {
  newSubscription: Subscription;
  filterSubject$ = new Subject<string>();
  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChildren(GlobalSearchCardComponent) globalSearchCardComponent: QueryList<GlobalSearchCardComponent>;
  isGlobal: boolean = true;
  value: string = '';
  label: string = '';
  right_width: number = 700;
  form: FormGroup;
  pageSize = 10;
  pageSizeOptions: number[] = PageSizeOptions;
  isShowEditor: boolean = false;
  loadEditor: boolean = true;
  code = '';
  showAll = false;
  editorOptions: MonacoEditorConstructionOptions = {
    theme: 'vs-dark',
    language: 'typescript',
    roundedSelection: true,
    autoIndent: 'full',
    readOnly: true,
    showDeprecated: false
  };

  filter = {
    SearchIndexes: [],
    Filter: '',
    PageNumber: 0,
    PageSize: 10
  };
  data: any[] = [];
  resultsLength: number;
  fetchspinner: boolean = false;
  chatHistory: AskByInventoryIdViewModel = <AskByInventoryIdViewModel>{};

  constructor(
    private helperService: HelperService,
    private dialogRef: MatDialogRef<GlobalSearchComponent>,
    private cloudConnectStateService: CloudConnectStateService,
    private dependencyMapService: DependencyMapService,
    private kumobotService: KumobotService,
    private aiService: AiService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }
  grabber = false;
  oldW = 0;
  left_width: number = 280;
  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.grabber) {
      return;
    }
    this.resizer(this.oldW - event.clientX);
    this.oldW = event.clientX;
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    if (event['target']['id'] == 'change_div_size') {
      this.grabber = false;
    }
  }

  resizer(offsetX: number) {
    this.right_width += offsetX;
    this.left_width += offsetX;
    if (this.right_width < 700) {
      this.right_width = 700;
      this.grabber = false;
    }
  }

  @HostListener('document:mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    if (event['target']['id'] == 'change_div_size') {
      this.grabber = true;
      this.oldW = event.clientX;
    }
  }

  toggleChips() {
    this.showAll = !this.showAll;
  }

  remove(data): void {
    let index = this.selectedItem.findIndex((x) => x.Id == data.Id);

    if (index > -1) {
      this.selectedItem.splice(index, 1);
    }

    let globalSearchCardComponents = this.globalSearchCardComponent.toArray();
    globalSearchCardComponents.forEach(item => {
      if(item.item.Id == data.Id) {
        item.onCardSelect();
      }
    })
    if(this.selectedItem.length === 0){
      this.messages = [];
    }
  }

  isCheckButton(type: string = 'device') {
    return this.filter.SearchIndexes.findIndex((x) => x == type) > -1;
  }

  onClickItem(type: string = 'device') {
    if (!this.isCheckButton(type)) {
      this.filter.SearchIndexes.push(type);
    } else {
      this.filter.SearchIndexes.splice(
        this.filter.SearchIndexes.findIndex((x) => x == type),
        1
      );
    }
    this.getData();
  }

  getData() {
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.filter.PageNumber = 0;
    this.globalSearch();
  }

  isCheckAllButton() {
    return this.filter.SearchIndexes.length == 0;
  }

  onClickAll() {
    if (!this.isCheckAllButton()) {
      this.filter.SearchIndexes = [];
    }
    this.getData();
  }

  ngOnInit(): void {
    this.getAllCloud();
    this.newSubscription = this.filterSubject$
      .pipe(debounceTime(800), distinctUntilChanged())
      .subscribe((value) => {
        this.getData();
      });
    // Load initial results so the page isn't blank on open
    this.globalSearch();
  }

  allClouds: any[] = [];
  getAllCloud() {
    return new Promise(async (resolve) => {
      if (this.allClouds.length > 0) {
        resolve(true);
      } else {
        this.dependencyMapService
          .getDependencyMapsCollectionEntriesForSelect()
          .subscribe((response) => {
            this.cloudConnectStateService.setCloudData(response);
            this.allClouds = response;
            resolve(true);
          });
      }
    });
  }

  onClose() {
    this.dialogRef.close();
    this.helperService.onClose(true);
  }

  sendQuickMessage(text: string) {
    this.query = text;
    this.send();
  }

  globalSearch() {
    this.fetchspinner = true;
    let filter = JSON.parse(JSON.stringify(this.filter));
      if(filter.SearchIndexes.length == 0) {
        filter.SearchIndexes = ['device', 'inventory', 'blueprint']
      }
      this.aiService.getAiIndexes(filter).subscribe(async (response) => {
        await this.getAllCloud();
        this.data = response.items;
        this.data.forEach((item) => {
          if (item.Name) {
            item['itemName'] = item.Name;
            item['itemType'] = 'Device';
          } else if (item.InventoryName) {
            item['itemName'] = item.InventoryName;
            item['itemType'] = 'Instance';
          } else if (item.BlueprintName) {
            item['itemName'] = item.BlueprintName;
            item['itemType'] = 'Blueprint';
          }
          if (item.Score) {
            item.Score = item.Score.toFixed(4);
            item.Score = Number(item.Score) * 1000;
            item.Score = item.Score.toFixed(2);
          }
          if (item.Provider) {
            item.Image = this.cloudConnectStateService.getImageByCloudKey(item.Provider);
          }
        });
        this.data.sort(function (a, b) {
          return b.Score - a.Score;
        });
        this.resultsLength = response.totalCount;
        this.fetchspinner = false;
      });
  }

  setGridParams() {
    this.filter.PageNumber = this.paginator.pageIndex;
    this.filter.PageSize = this.paginator.pageSize;
    this.globalSearch();
  }

  openConfig(item) {
    this.isShowEditor = true;
    this.code = item.RenderedText;
    this.right_width = 700;
    if (!this.sidenav.opened) {
    this.sidenav.open();
    }
  }

  selectedItem: any[] = [];
  onSelectCheckBox(item) {
    let index = this.selectedItem.findIndex((x) => x.Id == item.Id);
    if (index == -1) {
      this.selectedItem.push(item);
      // Auto-open the chat panel when the first item is selected
      this.isShowEditor = false;
      if (!this.sidenav.opened) {
        this.sidenav.open();
      }
    } else {
      this.selectedItem.splice(index, 1);
    }

    if(this.selectedItem.length === 0){
      this.messages = [];
    }
  }

  editorInit(editor: MonacoStandaloneCodeEditor) {
    this.loadEditor = false;
    editor.setSelection({
      startLineNumber: 1,
      startColumn: 1,
      endColumn: 50,
      endLineNumber: 3
    });
  }

  openCloseSidenav() {
    if (this.sidenav.opened) {
      this.isShowEditor = false;
      this.right_width = 700;
    }
    this.sidenav.toggle();
  }

  getHeight(height: number = 0) {
    const height_inner = (window.innerHeight - height).toString();
    return height_inner + 'px';
  }

  fetchingAiResponse: boolean = false;
  query: string = '';
  messages: any[] = [];
  currentId: string = '';
  firstMessage: string = '';
  type = 'inventory';

  thinkingLabel = 'Thinking';
  private thinkingLabels = [
    'Thinking', 'Reasoning', 'Analysing', 'Processing',
    'Searching', 'Synthesising', 'Planning', 'Inferring',
    'Connecting the dots', 'Inspecting', 'Evaluating', 'Exploring'
  ];
  private thinkingLabelIndex = 0;
  private thinkingInterval: any;
  private startThinkingAnimation() {
    this.thinkingLabelIndex = 0;
    this.thinkingLabel = this.thinkingLabels[0];
    clearInterval(this.thinkingInterval);
    this.thinkingInterval = setInterval(() => {
      this.thinkingLabelIndex = (this.thinkingLabelIndex + 1) % this.thinkingLabels.length;
      this.thinkingLabel = this.thinkingLabels[this.thinkingLabelIndex];
      this.cdr.detectChanges();
    }, 1800);
  }

  private stopThinkingAnimation() {
    clearInterval(this.thinkingInterval);
    this.thinkingLabel = 'Thinking';
  }

  send() {
    if (!this.query) {
      return;
    }
    this.fetchingAiResponse = true;
    this.startThinkingAnimation();
    let fullMessage = this.query;

    this.query = '';
    this.chatHistory.Items = this.selectedItem;
    this.chatHistory.Messages = [];
    if (this.messages.length > 1) {
      this.messages.forEach((message, index) => {
        if (message.from == 'me') {
          if (index == 0) {
            this.chatHistory.Messages.push({ role: 'user', content: this.firstMessage });
          } else {
            this.chatHistory.Messages.push({ role: 'user', content: message.message });
          }
        } else {
          this.chatHistory.Messages.push({ role: 'assistant', content: message.message });
        }
      });
    }
    this.currentId = uuid();
    this.chatHistory.Messages.push({ role: 'user', content: fullMessage, Id: this.currentId });
    this.messages.push({
      from: 'me',
      message: fullMessage,
      timestamp: this.kumobotService.getFormattedTime(),
      isFileUpload: false,
      fileDetails: '',
      textMessage: fullMessage
    });
    const defaults = this.kumobotService.getDefaultAiSettings(this.type);
    this.chatHistory.AiSetting = {
      Model: '04-mini',
      KumoBotRole: defaults.role,
      SpecificInstructions: defaults.instructions
    };
    this.aiService.ask(this.chatHistory).subscribe((messages) => {
      const receivedMessages = messages.Messages ?? messages;
      this.chatHistory.Messages = receivedMessages;
      let message = receivedMessages[receivedMessages.length - 1];
      this.messages.push({
        from: 'partner',
        message: message.content,
        timestamp: this.kumobotService.getFormattedTime(),
        isCompleted: true
      });
      this.fetchingAiResponse = false;
      this.stopThinkingAnimation();
    });
    setTimeout(() => {
      let chatElement = document.getElementById('chatElement');
      chatElement.scrollTop = chatElement.scrollHeight + 300;
    }, 100);
  }

  copyToClipboard(content: any, message: any): void {
    this.kumobotService.copyToClipboard(content, message);
  }

  onMarkdownClick = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    const anchor = target.closest('a') as HTMLAnchorElement;
    if (!anchor || !anchor.href) {
      return;
    }

    event.preventDefault();
    window.open(anchor.href, '_blank');
  };

  hasValidInput(): boolean {
    const message = this.query || '';
    let lastMessage = this.messages.find((x) => x.isCompleted == false);
    return message.trim().length > 0 && !lastMessage;
  }

  handleKeydown(event: KeyboardEvent) {
    if (this.fetchingAiResponse) {
      event.preventDefault();
      return;
    }

    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if (this.hasValidInput()) {
        this.send();
      }
    }
  }
}
